export const SourcePageEnum = {
       TEMPLATES_PAGE: 'templatesPage',
       CREATE_TICKET_PAGE: 'createTicketPage',
};
